export default "__VITE_ASSET__RrfHVtxa__"